import React from 'react';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
  :before {
    display: none;
  }
`;

const NextIcon = styled(MdNavigateNext)`
  font-size: 25px;
  color: #90A3C2;
`;

const PrevIcon = styled(MdNavigateBefore)`
  font-size: 25px;
  color: #90A3C2;
`;

const SlideArrow = ({ type, className, style, onClick }) => (
  <Wrapper
    className={className}
    style={style}
    onClick={onClick}
    role='button'
  >
    {type === 'next' ? <NextIcon /> : <PrevIcon /> }
  </Wrapper>
);

export default SlideArrow;
